//import dayjs from 'dayjs'
import Chart from 'chart.js'
import {Line} from 'vue-chartjs'

const draw = Chart.controllers.line.prototype.draw
Chart.controllers.line = Chart.controllers.line.extend({
  draw: function () {
    draw.apply(this, arguments)

    if (this.chart.tooltip._active && this.chart.tooltip._active.length && this.chart.scales['y-axis-1']) {
      const activePoint = this.chart.tooltip._active[0], ctx = this.chart.ctx, x = activePoint.tooltipPosition().x,
        topY = this.chart.scales['y-axis-1'].top, bottomY = this.chart.scales['y-axis-1'].bottom

      // draw line
      ctx.save()
      ctx.beginPath()
      ctx.moveTo(x, topY)
      ctx.lineTo(x, bottomY)
      ctx.lineWidth = 1
      ctx.strokeStyle = '#ccccd6'
      ctx.stroke()
      ctx.restore()
    }
  }
})

export default {
  name: 'data_center_line_chart',

  extends: Line,

  props: {
    key_metrics: {},
    period: '',
    start_time: null,
    key_list: null,
    selected_key: '',
    selected_key_list: null,
    order_type: ''
  },

  data() {
    return {
      chart_data: {
        labels: [], datasets: []
      }, options: {
        layout: {padding: {left: -1000}}, responsive: true, maintainAspectRatio: false, tooltips: {
          titleFontSize: 12, bodyFontSize: 12, enabled: true, mode: 'label', intersect: false, callbacks: {
            title: function (tooltipItems) {
              if (tooltipItems[0] && tooltipItems[0].xLabel) {
                return tooltipItems[0].xLabel
                  .replace(/^.+\(/, '')
                  .replace(/[()]/ig, '')
              } else {
                return ''
              }
            }, label: function (tooltipItems, data) {
              const value = tooltipItems.yLabel % 1 === 0 ? tooltipItems.yLabel.toString().replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1,') : tooltipItems.yLabel.toFixed(2).replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1,')
              return data.datasets[tooltipItems.datasetIndex].label + ': ' + value
            }
          }
        }, legend: {
          display: false
        }, scales: {
          xAxes: [{
            display: true, gridLines: {
              display: false
            }, ticks: {
              callback: function (label) {
                return label.replace(/\(.+\)/, '')
              }
            }
          }], yAxes: [{
            id: 'y-axis-1', position: 'left', display: true, ticks: {
              display: false, beginAtZero: true, maxTicksLimit: 7
            }, gridLines: {
              display: true, borderDash: [8, 4], color: 'rgb(229,229,229)'
            }
          }, {
            id: 'y-axis-2', position: 'left', ticks: {
              display: false, beginAtZero: true, maxTicksLimit: 7
            }, gridLines: {
              display: false
            }
          }, {
            id: 'y-axis-3', position: 'left', ticks: {
              display: false, beginAtZero: true, maxTicksLimit: 7
            }, gridLines: {
              display: false
            }
          }, {
            id: 'y-axis-4', position: 'left', ticks: {
              display: false, beginAtZero: true, maxTicksLimit: 7
            }, gridLines: {
              display: false
            }
          }]
        }, hover: {
          mode: 'nearest', intersect: false, axis: 'xy'
        }
      }, dataset_template: {
        label: 'Chỉ số',
        data: [40, 65, 80, 81, 56, 55],
        point: '0',
        type: 'line',
        pointBorderWith: 0,
        lineTension: 0,
        showLines: true,
        backgroundColor: 'transparent',
        pointHoverBorderColor: 'transparent',
        pointHoverBorderWidth: 0,
        pointBorderColor: 'transparent',
        pointBackgroundColor: 'transparent',
        pointHoverBackgroundColor: 'transparent',
        borderColor: 'rgb(54, 127, 227)',
        yAxisID: 'y-axis-1'
      }
    }
  },

  watch: {
    key_metrics: function () {
      this.m__render_chart_2()
    },

    selected_key_list: function (new_val, old_val) {
      if (new_val.length !== old_val.length) {
        this.m__render_chart_2()
      }
    }
  },

  mounted() {
    this.chart_data.labels = ['']
    this.chart_data.datasets = [{}]
    // this.renderChart(this.chart_data, this.options)
    this.m__render_chart_2()
  },

  methods: {
    m__generate_label() {
      const result = []
      let date = this.dayjs(this.start_time * 1000).startOf('d')

      if (['', 'real_time', 'yesterday', 'day'].includes(this.period)) {
        for (let i = 0; i <= 23; i++) {
          date.set('hour', i)
          if (i % 6 === 0) {
            result.push(`${i} (${date.format('HH:mm DD-MM-YYYY')})`)
          } else {
            result.push(`(${date.format('HH:mm DD-MM-YYYY')})`)
          }
        }
      } else if (['past7days', 'week'].includes(this.period)) {
        for (let i = 1; i <= 7; i++) {
          let is_previous_month = false
          if (i > 1 && !is_previous_month) {
            const previous_day = date.clone().subtract(1, 'd')
            if (previous_day.date() > date.date()) {
              is_previous_month = true
            }
          }

          result.push(`${is_previous_month ? `${date.date()} Tháng ${date.month() + 1}` : date.date()} (${date.format('DD-MM-YYYY')})`)
          date = date.add(1, 'd')
        }
      } else if (['past30days'].includes(this.period)) {
        let is_odd = true
        for (let i = 1; i <= 30; i++) {
          let is_previous_month = false
          if (i > 1 && !is_previous_month) {
            const previous_day = date.clone().subtract(1, 'd')
            if (previous_day.date() > date.date()) {
              is_previous_month = true
            }
          }

          if (is_previous_month) {
            result[i - 2] = `(${date.clone().subtract(1, 'd').format('DD-MM-YYYY')})`
          }

          if (is_previous_month && i % 2 === 0) {
            is_odd = false
          }

          if (is_odd) {
            if (i % 2 !== 0) {
              result.push(`${is_previous_month ? `${date.date()} Tháng ${date.month() + 1}` : date.date()} (${date.format('DD-MM-YYYY')})`)
            } else {
              result.push(`(${date.format('DD-MM-YYYY')})`)
            }
          } else {
            if (i % 2 === 0) {
              result.push(`${is_previous_month ? `${date.date()} Tháng ${date.month() + 1}` : date.date()} (${date.format('DD-MM-YYYY')})`)
            } else {
              result.push(`(${date.format('DD-MM-YYYY')})`)
            }
          }

          date = date.add(1, 'd')
        }
      } else if (['month'].includes(this.period)) {
        const days_in_month = date.daysInMonth()
        for (let i = 1; i <= days_in_month; i++) {
          if (i === 1) {
            result.push(`${i} Tháng ${date.month() + 1} (${date.format('DD-MM-YYYY')})`)
          } else if (i % 2 !== 0) {
            result.push(`${i} (${date.format('DD-MM-YYYY')})`)
          } else {
            result.push(`(${date.format('DD-MM-YYYY')})`)
          }

          date = date.add(1, 'd')
        }
      } else if (['year'].includes(this.period)) {
        for (let i = 1; i <= 12; i++) {
          if (i === 1) {
            result.push(`Tháng 1 2002 (${date.format('MM-YYYY')})`)
          } else {
            result.push(`Tháng ${i} (${date.format('MM-YYYY')})`)
          }
          date = date.add(1, 'month')
        }
      }
      this.chart_data.labels = result
    },

    m__render_chart_2() {
      if (!this.key_metrics) {
        this.chart_data.datasets = []
        this.renderChart(this.chart_data, this.options)
        return
      }

      this.m__generate_label()
      this.chart_data.datasets = []

      let index = 1
      for (const key_item of this.selected_key_list) {
        let key_string = key_item
        if (this.order_type !== '') {
          key_string = key_string.replace(/(placed|place)/, this.order_type)
        }

        const key_obj = this.key_metrics[key_string]
        if (key_obj) {
          const dataset = {...this.dataset_template}
          dataset.data = []
          dataset.label = this.key_list[key_item].name
          dataset.borderColor = this.key_list[key_item].color
          dataset.pointBackgroundColor = this.key_list[key_item].color
          dataset.yAxisID = `y-axis-${index++}`
          for (const item of key_obj.points) {
            dataset.data.push(item.value)
          }
          this.chart_data.datasets.push(dataset)
        }
      }

      this.renderChart(this.chart_data, this.options)
    },

    m__render_chart() {
      let key_string = this.selected_key
      if (this.order_type !== '') {
        key_string = key_string.replace(/(placed|place)/, this.order_type)
      }

      this.chart_data.datasets[0].label = this.key_list[this.selected_key].name
      this.chart_data.datasets[0].borderColor = this.key_list[this.selected_key].color

      if (!this.key_metrics) {
        this.chart_data.datasets[0].data = []
        this.renderChart(this.chart_data, this.options)
        return
      }

      const key = this.key_metrics[key_string]
      if (key) {
        this.m__generate_label()
        this.chart_data.datasets[0].data = []
        for (const item of key.points) {
          // console.log(`${this.dayjs(item.timestamp * 1000).format('DD-MM-YYYY HH:mm')} - ${item.value}`)
          this.chart_data.datasets[0].data.push(item.value)
        }
      }

      this.renderChart(this.chart_data, this.options)

      // this.chart_data.datasets.push({
      //   label: 'Chỉ số',
      //   data: [40, 65, 80, 81, 56, 55],
      //   point: '0',
      //   type: 'line',
      //   pointBorderWith: 0,
      //   lineTension: 0,
      //   showLines: true,
      //   backgroundColor: 'transparent',
      //   pointHoverBorderColor: 'transparent',
      //   pointHoverBorderWidth: 0,
      //   pointBorderColor: 'transparent',
      //   pointBackgroundColor: 'transparent',
      //   pointHoverBackgroundColor: 'transparent',
      //   borderColor: 'rgb(148, 95, 185)',
      //   yAxisID: 'y-axis-2'
      // })
      //
      // this.chart_data.datasets.push({
      //   label: 'Chỉ số',
      //   data: [140, 165, 180, 181, 156, 155],
      //   point: '0',
      //   type: 'line',
      //   pointBorderWith: 0,
      //   lineTension: 0,
      //   showLines: true,
      //   backgroundColor: 'transparent',
      //   pointHoverBorderColor: 'transparent',
      //   pointHoverBorderWidth: 0,
      //   pointBorderColor: 'transparent',
      //   pointBackgroundColor: 'transparent',
      //   pointHoverBackgroundColor: 'transparent',
      //   borderColor: 'rgb(251, 115, 75)',
      //   yAxisID: 'y-axis-3'
      // })
    }
  }
}



// WEBPACK FOOTER //
// ./src/pages/center/line_chartjs.js